export default [
  {
    path: '/rent/v2/pay/:id?',
    name: 'pay',
    component: () => import('@/pages/pay/index'),
    meta: { title: '收银台', requireAuth: true },
  },
    {
        path: '/rent/v2/payResult',
        name: 'payResult',
        component: () => import('@/pages/pay/payResult'),
        meta: { title: '订单支付', requireAuth: true },
    },
    {
        path: '/rent/v2/notFound',
        name: 'notFound',
        component: () => import('@/pages/pay/notFound'),
        meta: { title: '页面不存在' },
    },
    {
      path: '/rent/v2/payCenter',
      name: 'payCenter',
      component: () => import('@/pages/pay/payCenter'),
      meta: { title: '支付中...' },
  },
]



// WEBPACK FOOTER //
// ./src/pages/pay/pay.js